<app-sub-menu [subMenus]="subMenus"></app-sub-menu>
<div class="container-fluid bg-box">
  <div class="row mb-3">
    <div class="col">
      <h3>
        Tipo de revision:
        <span style="color: #666f6f">{{ tipoRevision?.Descripcion }}</span>
      </h3>
      <p>Listado de los checklist del tipo de revisión</p>
    </div>
    <div class="col text-right">
      <a
        routerLink="../../ChecklistPaso1/0/{{ idTipoRevision }}"
        class="btn btn-sm btn-primary"
        ><i class="fa fa-plus"></i> Nuevo checklist</a
      >
    </div>
  </div>
  <hr />
  <div class="row">
    <div class="col-12">
      <div class="table-responsive">
        <table class="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th scope="col">Estatus</th>
              <th scope="col">Folio</th>
              <th scope="col">Nombre</th>
              <th scope="col">ponderacion</th>
              <th scope="col">Tipo de revisión</th>
              <th scope="col">Detalle</th>
              <th scope="col">Editar</th>
              <th scope="col">Duplicar</th>
              <th scope="col">Publicar</th>
              <th scope="col">Desactivar</th>
              <th scope="col">Eliminar</th>
            </tr>
          </thead>
          <tbody *ngIf="source; else loading">
            <tr *ngFor="let item of source">
              <td>
                <div class="badges">
                  <span
                    [ngStyle]="{ 'background-color': item.Etapa.Color }"
                    class="badges--publicado"
                  >
                    {{ item.Etapa.Descripcion }}
                  </span>
                </div>
              </td>
              <td>{{ item.IdChecklist }}</td>
              <td>{{ item.Nombre }}</td>
              <td>{{ item.Ponderacion }}</td>
              <td>{{ item.TipoRevision.Descripcion }}</td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-secondary rounded-circle"
                  routerLink="../../ChecklistDetalle/{{ item.IdChecklist }}"
                >
                  <i class="fa fa-search"></i>
                </button>
              </td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-primary rounded-circle"
                  [disabled]="item.IdEtapa != 2"
                  routerLink="../../ChecklistPaso1/{{ item.IdChecklist }}/{{
                    idTipoRevision
                  }}"
                >
                  <i class="fa fa-pencil"></i>
                </button>
              </td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-primary rounded-circle"
                  [disabled]="item.IdEtapa === 2"
                  (click)="duplicarClick(item.IdChecklist)"
                  data-bs-toggle="modal"
                  data-bs-target="#modalEdit"
                >
                  <i class="fa fa-retweet"></i>
                </button>
              </td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-success rounded-circle"
                  [disabled]="item.IdEtapa !== 2"
                  (click)="publishClick(item)"
                >
                  <i class="fa fa-upload"></i>
                </button>
              </td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-danger rounded-circle"
                  [disabled]="item.IdEtapa !== 3"
                  (click)="cancelClick(item)"
                >
                  <i class="fa fa-eye-slash" aria-hidden="true"></i>
                </button>
              </td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-danger rounded-circle"
                  [disabled]="item.IdEtapa === 3 || isDeleteChecklist"
                  (click)="deleteClick(item.IdChecklist)"
                >
                  <i class="fa fa-minus"></i>
                </button>
              </td>
            </tr>
          </tbody>
          <ng-template #loading>
            <tbody>
              <tr *ngFor="let item of [].constructor(4)">
                <td colspan="3">
                  <div
                    class="w-100 p-3 rounded border border-white skeleton"
                  ></div>
                </td>
                <td colspan="3">
                  <div
                    class="w-100 p-3 rounded border border-white skeleton"
                  ></div>
                </td>
                <td colspan="3">
                  <div
                    class="w-100 p-3 rounded border border-white skeleton"
                  ></div>
                </td>
                <td colspan="3">
                  <div
                    class="w-100 p-3 rounded border border-white skeleton"
                  ></div>
                </td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </div>
    </div>
  </div>
</div>

<!--Modal nombre de check list clonado-->
<div
  class="modal fade bd-example-modal-lg"
  id="modalNombreCheckList"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalAltaRevisionLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header modal-">
        <h2>Nombre Check List</h2>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <app-form-duplicar-checklist [idCheckList]="idCheckListC" (emitDuplicado)="checklistDuplicado($event)" ></app-form-duplicar-checklist>
    </div>
  </div>
</div>
